import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import axios from 'axios';
import './Verify.scss'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import JejakinLogo from './../../../images/jejakin-logo.svg';

class Verify extends Component {
   constructor(props) {
      super(props);
      this.state = {
         isVerified : false,
         verify : false
      };
   }

   verifyAccount = async (e) => {
      axios({
         method: 'POST',
         url: process.env.REACT_APP_API_HOST + '/user/verify/' + this.props.match.params.token,
      }).then(
         (response) => {
            if(response.data.status === true){
               this.setState({verify : true})
            }
            else{
               if(response.data.error[0] === 'This user already verified')
               {
                  this.setState({isVerified : true})
               }
               else 
               {
                  toast.error("Error! "+  response.data.error);
               }
            }
         }
      );
   }

   componentDidMount(){
      setTimeout(this.verifyAccount, 2000);
   }

   render() {
      if(this.state.isVerified === true){
         return (<Redirect to={'/login'}/>)
      } 
      return (
         <div className="content-page verify">
            <ToastContainer />
            <div className="card shadow" style={{width:'400px', margin: 'auto', position:'absolute', left:'50%', top:'50%', transform:'translate(-50%, -50%)', height:'auto'}}>
               <div className="card-body">
                  <div className="box-logo">
                     <Link to="/">
                     <img src={JejakinLogo} alt="Jejak Offset" />
                     </Link>
                  </div>
                  {
                     this.state.verify === true ? (
                        <div className="text-center box-verify success">
                           <i className="fa fa-check"></i>
                           <br/><br/>
                           <span>Your account has been verified</span>
                           <br/>
                           <div className="form-group">
                           <Link to="/login" className="btn btn-link-orange">
                              Login to continue
                           </Link>
                           </div>
                        </div>
                     ) : (
                        <div className="text-center box-verify">
                           <span>
                              <i className="fa fa-spinner fa-spin"></i>
                              <br/><br/>
                              Verifying your account..
                           </span>
                           <br/>
                        </div>
                     )
                  }
               </div>
            </div>
         </div>
      );
   }
}
   
export default Verify;